import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(
      () => import("views/auth-views/authentication/login"),
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/forgot-password"),
    ),
  },
  {
    key: "resend-email",
    path: `${AUTH_PREFIX_PATH}/success-send-email`,
    component: React.lazy(
      () => import("views/auth-views/authentication/resend-email/forgot"),
    ),
  },
  {
    key: "reset-password",
    path: `${AUTH_PREFIX_PATH}/reset-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/reset-password"),
    ),
  },
  {
    key: "change-password",
    path: `${AUTH_PREFIX_PATH}/change-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/change-password"),
    ),
  },
  {
    key: "error",
    path: `*`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-1")),
    meta: {
      blankLayout: true,
    },
  },
];
export const publicNoRedirect = [
  {
    key: "invoice",
    path: `/invoice/:id`,
    component: React.lazy(() => import("views/app-views/invoice")),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "invoice-print",
    path: `/invoice/print/:id`,
    component: React.lazy(() => import("views/app-views/invoice/print")),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "pengantar-invoice",
    path: `/pengantar-invoice/:id`,
    component: React.lazy(() => import("views/app-views/pengantar-invoice")),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "pengantar-invoice-print",
    path: `/pengantar-invoice/print/:id`,
    component: React.lazy(
      () => import("views/app-views/pengantar-invoice/print"),
    ),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "bstb",
    path: `/bstb/:id`,
    component: React.lazy(() => import("views/app-views/bstb")),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "bstb-print",
    path: `/bstb/print/:id`,
    component: React.lazy(() => import("views/app-views/bstb/print")),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "lacak",
    path: `/lacak`,
    component: React.lazy(() => import("views/app-views/lacak")),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "check-ongkir",
    path: `/cek-ongkir`,
    component: React.lazy(() => import("views/app-views/check-ongkir")),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "lacak",
    path: `/lacak`,
    component: React.lazy(() => import("views/app-views/lacak")),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "embedlacak-resi",
    path: `/embed/lacak-resi/:code`,
    component: React.lazy(() => import("views/app-views/resi-embed")),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "lacak-resi",
    path: `/lacak-resi/:code`,
    component: React.lazy(() => import("views/app-views/resi")),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "scan-qrcode",
    path: `/scan`,
    component: React.lazy(() => import("views/app-views/scan-qr")),
    meta: {
      blankLayout: true,
    },
  },
];

export const protectedRoutes = [
  {
    key: "dashboard",
    path: `${APP_PREFIX_PATH}`,
    component: React.lazy(() => import("views/app-views/onboarding")),
  },
  {
    key: "booking-order",
    path: `${APP_PREFIX_PATH}/booking-order`,
    component: React.lazy(() => import("views/app-views/booking-order")),
  },
  {
    key: "booking-order-detail",
    path: `${APP_PREFIX_PATH}/booking-order/detail`,
    component: React.lazy(() => import("views/app-views/booking-order/detail")),
  },
  {
    key: "booking-order-form",
    path: `${APP_PREFIX_PATH}/booking-order/form`,
    component: React.lazy(() => import("views/app-views/booking-order/form")),
  },
  {
    key: "voyage",
    path: `${APP_PREFIX_PATH}/voyage`,
    component: React.lazy(() => import("views/app-views/voyage")),
  },
  {
    key: "history",
    path: `${APP_PREFIX_PATH}/history`,
    component: React.lazy(() => import("views/app-views/history")),
  },
  {
    key: "soa",
    path: `${APP_PREFIX_PATH}/soa`,
    component: React.lazy(() => import("views/app-views/statement-of-account")),
  },
  {
    key: "soa-form",
    path: `${APP_PREFIX_PATH}/soa/form`,
    component: React.lazy(
      () => import("views/app-views/statement-of-account/manage"),
    ),
  },
  {
    key: "shipping-address",
    path: `${APP_PREFIX_PATH}/shipping-address`,
    component: React.lazy(() => import("views/app-views/shipping-address")),
  },
  {
    key: "shipping-address-detail",
    path: `${APP_PREFIX_PATH}/shipping-address/detail`,
    component: React.lazy(
      () => import("views/app-views/shipping-address/detail"),
    ),
  },
  {
    key: "shipping-address-form",
    path: `${APP_PREFIX_PATH}/shipping-address/form`,
    component: React.lazy(
      () => import("views/app-views/shipping-address/form"),
    ),
  },
  {
    key: "shipping-address-alamat-form",
    path: `${APP_PREFIX_PATH}/shipping-address/form`,
    component: React.lazy(
      () => import("views/app-views/shipping-address/address/form"),
    ),
  },
  // Profile
  {
    key: "my-profile",
    path: `${APP_PREFIX_PATH}/profile`,
    component: React.lazy(() => import("views/app-views/profile")),
  },
  {
    key: "error",
    path: `*`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-1")),
    meta: {
      blankLayout: true,
    },
  },
];
